import endpoints from '@/utils/constants';
import { apiHelper } from '@/utils/helpers';

const actions = {
    getMaxInvoiceNumber(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.invoices}/max/number`).then((res) => {
                if (res.status === 201) {
                    context.commit('setInvoiceNumber', res.data.invoiceNumber)
                }
            }).catch(err => {
                reject(err);
            })
        })
    }
}


export default actions;